<!-- 交易总揽数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "../../../commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"parkCodeList":["2KKN885S"]},
            responseCode: {
                    "data": {
                        "alipayNumber": 0,
                        "alipayNumberPrecent": "0%",
                        "ectNumberPrecent": "0%",
                        "etcNumber": 0,
                        "offlineNumber": 7,
                        "offlineNumberPrecent": "100.0%",
                        "onlineNumber": 0,
                        "onlineNumberPrecent": "0.0%",
                        "otherNumber": 0,
                        "otherNumberPrecent": "0%",
                        "transactionAmount": 2218.69,
                        "transactionAmountStr": "2218.69",
                        "transactionNumber": 368,
                        "transactionNumberStr": "368",
                        "wechatNumber": 0,
                        "wechatNumberPrecent": "0%",
                        "yesterdayTransactionAmount": 0.07,
                        "yesterdayTransactionAmountStr": "0.07",
                        "yesterdayTransactionNumber": 7,
                        "yesterdayTransactionNumberStr": "7"
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取交易总览数据",
                t_url: this.commonUrls.test+"dealSummarise",
                p_url: this.commonUrls.prod+"dealSummarise",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '停车场编码数组' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'yesterdayTransactionAmount', info2: '是', info3: 'Decimal', info4: '昨日交易金额' },
                        { info1: 'yesterdayTransactionAmountStr', info2: '是', info3: 'String', info4: '昨日交易金额（以万形式显示）' },
                        { info1: 'yesterdayTransactionNumber', info2: '是', info3: 'long', info4: '昨日交易次数' },
                        { info1: 'yesterdayTransactionNumberStr', info2: '是', info3: 'String', info4: '昨日交易次数（以万形式显示）' },
                        { info1: 'transactionAmount', info2: '是', info3: 'Decimal', info4: '年度交易金额' },
                        { info1: 'transactionAmountStr', info2: '是', info3: 'String', info4: '年度交易金额（以万形式显示）' },
                        { info1: 'transactionNumber', info2: '是', info3: 'long', info4: '年度交易次数' },
                        { info1: 'transactionNumberStr', info2: '是', info3: 'String', info4: '年度交易次数（以万形式显示）' },
                        { info1: 'onlineNumber', info2: '是', info3: 'long', info4: '线上交易次数' },
                        { info1: 'onlineNumberPrecent', info2: '是', info3: 'String', info4: '线上交易次数占比' },
                        { info1: 'offlineNumber', info2: '是', info3: 'long', info4: '线下交易次数' },
                        { info1: 'offlineNumberPrecent', info2: '是', info3: 'String', info4: '线下交易次数占比' },
                        { info1: 'alipayNumber', info2: '是', info3: 'long', info4: '支付宝交易次数' },
                        { info1: 'alipayNumberPrecent', info2: '是', info3: 'String', info4: '支付宝交易次数占比' },
                        { info1: 'wechatNumber', info2: '是', info3: 'long', info4: '微信交易次数' },
                        { info1: 'wechatNumberPrecent', info2: '是', info3: 'String', info4: '微信交易次数占比' },
                        { info1: 'etcNumber', info2: '是', info3: 'long', info4: 'ETC交易次数' },
                        { info1: 'ectNumberPrecent', info2: '是', info3: 'String', info4: 'ETC交易次数占比' },
                        { info1: 'otherNumber', info2: '是', info3: 'long', info4: '其他交易次数' },
                        { info1: 'otherNumberPrecent', info2: '是', info3: 'String', info4: '其他交易次数占比' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/dealSummarise.vue